import React from 'react';

import { noop } from 'ui-components/default-props/noop';

import { ProviderTypes } from './constants';
import { CuiProviderRegistration } from './provider-registration';

type FreightProviderRegistrationProps = {
  providerApiCode: string;
  onBack?: () => void;
  onRegisterSuccess?: (data?: unknown) => void;
  onRegisterFailure?: (error?: unknown) => void;
  onError?: (error?: unknown) => void;
  onCancel?: () => void;
};

export const FreightProviderRegistration = ({
  providerApiCode,
  onBack = noop,
  onRegisterSuccess = noop,
  onRegisterFailure = noop,
  onError = noop,
  onCancel = noop,
}: FreightProviderRegistrationProps) => {
  return (
    <CuiProviderRegistration
      onBack={onBack}
      onCancel={onCancel}
      onError={onError}
      onRegisterFailure={onRegisterFailure}
      onRegisterSuccess={onRegisterSuccess}
      providerApiCode={providerApiCode}
      providerType={ProviderTypes.freight}
    />
  );
};
